import { useState } from "react";
import { Button, Form, Modal, message } from "antd";

import Heading from "components/Heading/Heading";
import DataTable from "components/Tables/DataTable";
import {
  useAddStoreMutation,
  useDeleteStoreMutation,
  useEditStoreMutation,
  useGetStoresQuery,
} from "../../../redux/Service/storesApi";
import FormModal from "./FormModal";

function StoresCodes() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const { data: storesData, isLoading } = useGetStoresQuery(undefined);
  const stores = storesData?.ResponseObject ?? [];

  const [addStore, { isLoading: isAdding }] = useAddStoreMutation();
  const [updateStore, { isLoading: isUpdating }] = useEditStoreMutation();
  const [deleteStore, { isLoading: isDeleting }] = useDeleteStoreMutation();

  const columns: any = [
    {
      title: "كود المخزن",
      dataIndex: "StoreID",
      key: "StoreID",
    },
    {
      title: "اسم المخزن",
      dataIndex: "StoreName",
      key: "StoreName",
      width: 150,
    },
    {
      title: "اسم البائع",
      dataIndex: "SellerName",
      key: "SellerName",
    },
    {
      title: "اسم الحساب",
      dataIndex: "AccName",
      key: "AccName",
    },
    {
      title: "العنوان",
      dataIndex: "Address",
      key: "Address",
    },
    {
      title: "مخزن حقيقي",
      dataIndex: "IsRealStock",
      key: "IsRealStock",
    },
  ];

  const handleOk = async (values: any) => {
    try {
      let response;

      if (isEditing) {
        response = await updateStore(values).unwrap();
      } else {
        response = await addStore(values).unwrap();
      }

      if (response?.ResponseObject === true) {
        message.success(
          isEditing ? "تم تعديل المخزن بنجاح" : "تمت إضافة المخزن بنجاح"
        );
        setIsModalOpen(false);
        resetModal();
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch (error) {
      message.error("فشل الاتصال بالخادم");
    }
  };

  function resetModal() {
    form.resetFields();
    setIsEditing(false);
  }

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModal();
  };

  const handleDeleteClick = (record: any) => {
    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد أنك تريد حذف المخزن "${record.StoreName}"؟`,
      okText: "حذف",
      okType: "danger",
      cancelText: "إلغاء",
      onOk: async () => {
        try {
          const response = await deleteStore(record.StoreID).unwrap();
          if (response?.ResponseObject === true) {
            message.success("تم حذف المخزن بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch (error) {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const handleEditClick = (record: any) => {
    setIsEditing(true);
    setIsModalOpen(true);
    setTimeout(() => {
      form.setFieldsValue(record);
    }, 0);
  };

  return (
    <>
      <Heading name={"المخازن"} />
      <div className="flex flex-wrap gap-4 relative">
        <div className="grid justify-start">
          <Button type="primary" onClick={() => setIsModalOpen(true)}>
            إضافة مخزن
          </Button>
        </div>

        <FormModal
          form={form}
          stores={stores}
          isEditing={isEditing}
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
          loading={isUpdating || isAdding}
        />

        <DataTable
          columns={columns}
          data={stores}
          handleEditClick={handleEditClick}
          handleDeletClick={handleDeleteClick}
          isLoading={isLoading || isDeleting}
        />
      </div>
    </>
  );
}

export default StoresCodes;
